<template>
  <div id="app">
    <div class="cover-container d-flex w-100 h-100 mx-auto flex-column">
      <header class="mb-auto">
        <!-- *** -->
        <nav class="navbar navbar-expand-xxl navbar-dark fixed-top bg-dark">
          <div class="container-fluid">
            <b-navbar toggleable="xxl" type="dark">
              <b-navbar-brand>
                <router-link to="/" class="nav-link logo"
                  >Stromvatten.se</router-link
                >
              </b-navbar-brand>
              <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
              <b-collapse id="nav-collapse" is-nav>
                <b-navbar-nav class="ml-auto">
                  <b-dropdown-item>
                    <router-link to="/Bolman" class="nav-link"
                      >Bolmån</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="/Glomma" class="nav-link"
                      >Glomma</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="/Giman" class="nav-link"
                      >Gimån</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item>
                    <router-link to="/Herrevadsstrommen" class="nav-link"
                      >Herrevadsströmmen</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/Trysilelva" class="nav-link"
                      >Trysilelva</router-link
                    >
                  </b-dropdown-item>
                  <b-dropdown-item href="#">
                    <router-link to="/Atran" class="nav-link"
                      >Ätran</router-link
                    >
                  </b-dropdown-item>
                </b-navbar-nav>
                <!-- Right aligned nav items -->
                <!-- <b-navbar-nav class="ml-auto"> Login </b-navbar-nav> -->
              </b-collapse>
            </b-navbar>
          </div>
        </nav>
        <!-- *** -->
      </header>
      <main role="main" class="cover">
        <router-view />
      </main>
      <footer class="light">
        <Footercomponent />
      </footer>
    </div>
  </div>
</template>
<script>
import Footercomponent from "@/components/Footercomponent.vue";

export default {
  name: "App",
  components: {
    Footercomponent,
  },
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

body {
  text-shadow: 0 0.05rem 0.1rem rgba(0, 0, 0, 0.7);
  /*box-shadow: inset 0 0 2rem rgba(0, 0, 0, 0.5); */
  background-color: #020;
}

.logo {
  font-family: "Sacramento", cursive !important;
  font-size: 1.5rem;
  float: right;
}

p {
  font-family: "Castoro", serif;
}

h1 {
  font-family: "Sacramento", cursive;
  font-size: 3rem;
  color: #eee;
}

footer {
  padding-top: 10px;
  /* font-family: "Sacramento", cursive; */
  color: #fff;
  a {
    color: #aaa;
    font-weight: 700;
  }
  a:hover {
    color: #ddd;
    text-decoration: none;
  }
}

/* .bd-placeholder-img {
  font-size: 1.125rem;
  text-anchor: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
}
 */
.carousel-item {
  height: 90vh !important;
  width: 100% !important;
  min-height: 550px;
}

.bg-dark {
  background-color: rgba(0, 0, 0, 0) !important;
  a {
    color: #fff;
  }
}

/* .inne {
  margin-top: 0;
} */

.navbar {
  padding: 0 5px;
}

.dropdown {
  margin-top: 6px;
}

.dropdown-menu {
  background-color: rgba(0, 0, 0, 0.5) !important;
  a {
    color: #333;
  }
  a:hover {
    background-color: rgba(0, 0, 0, 1) !important;
    color: #fff !important;
  }
}

.carousel-inner {
  width: 100vw !important;
  height: auto !important;
  object-fit: cover !important;
}

.carousel-inner img {
  width: 100% !important;
  min-height: 100% !important;
  object-fit: cover !important;
  overflow: hidden !important;
}

@media (max-width: 768px) {
  /*   .bd-placeholder-img-lg {
    font-size: 1.5rem;
  } */
  .carousel-inner img {
    height: 90vh !important;
    width: 100vw !important;
    object-fit: cover !important;
    overflow: hidden !important;
  }
  /*   .carousel-item img {
    object-fit: cover !important;
  } */
  .carousel-item h1 {
    margin-top: 30px;
  }
  h1 {
    font-size: 1.7rem;
  }
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin: 0;
}
</style>
